@if (selectedSale()) {
    <div class="estate-sale-infocard-wrapper">
        <div class="mini-infocard">
            <div class="header">
                <div class="header-wrapper">
                    <div class="description-wrapper">
                        <three-dot-navigation [menuItems]="menuItems()"></three-dot-navigation>
                        <div class="description">
                            <div class="title">
                                @if (selectedSale().isWithdrawn || selectedSale().isOutdated) {
                                    <div class="withdrawn">T</div>
                                }
                                <h3>{{ selectedSale().streetAddress }}</h3>
                            </div>
                            @if (selectedSale().postalAddress) {
                                <h3>{{ selectedSale().postalAddress }}</h3>
                            }

                            @if (!selectedSale().isAttachedSale) {
                                <div class="subtitle">
                                    <p>{{ selectedSale().ownershipEstateTypeDisplayText }}</p>
                                    <p>{{ selectedSale().identificationText | dash }}</p>
                                </div>
                            }
                        </div>
                    </div>
                    @if (selectedSale().isAttachedSale) {
                        <div class="attached-sales">
                            <ev_tooltip
                                [visible]="showAttachedInfo"
                                [left]="44"
                                [top]="65"
                                [arrow]="'left'"
                                [arrowBottomAlign]="55"
                                [arrowAlignLeft]="-7"
                                (close)="showAttachedInfo = false"
                            >
                                <div class="popup-info">
                                    <div class="body">
                                        Dette er en markedsobservasjon som vi ikke har greid å knytte til en omsetning av en helt spesifikk eiendom.
                                        Informasjonen er imidlertid nyttig i statistikksammenheng og omsetninger er lokalisert i dette området.
                                    </div>
                                </div>
                            </ev_tooltip>
                            <div class="info-icon" (click)="showAttachedInfo = !showAttachedInfo"></div>
                            <div class="info-text">Omsetning ikke tilknyttet en spesifikk eiendom</div>
                        </div>
                    }
                </div>
                <div class="right-side">
                    <button class="close" (click)="close()"></button>
                    @if (hasFavoritelistRole()) {
                        <div class="shopping-cart" (click)="modifyCart($event)">
                            @if (mapState().estateListEditMode) {
                                <div class="shopping-cart-icon" [class.in-cart]="inCart()"></div>
                            }
                        </div>
                    }
                </div>
            </div>
            <div class="map-buttons">
                <button class="center-map" (click)="centerMap()">
                    <div class="center-map-icon"></div>
                    <span>Sentrer</span>
                </button>
                <button class="show-position" (click)="showInMap()">
                    <div class="show-position-icon"></div>
                    <span>Vis Posisjon</span>
                </button>
            </div>
            <mini-infocard-image-carousel [selectedSale]="selectedSale()" [imagePackages]="imagePackages()"></mini-infocard-image-carousel>
            <estate-sale-infocard-properties [selectedSale]="selectedSale()"></estate-sale-infocard-properties>
        </div>
    </div>
}
